import { Icon } from "~/common/components/icon/Icon";
import { type IconType } from "~/common/components/icon/IconType";
import { IconButton, type IconButtonProps, styled } from "~/common/mui";
import { CORNER_EXTRA_SMALL } from "~/common/components/icon/Corners";

export interface SideButtonProps extends Omit<IconButtonProps, "children"> {
  icon: IconType;
  href?: string;
}

/**
 * @deprecated Double check with design team before using in a new place
 * Component representing a square button that only contains an icon.
 * Usually placed on the side of a primary button.
 *
 * Icon size is always 24px.
 */
export const SideButton = styled((props: SideButtonProps) => {
  const { color = "secondary", ...rest } = props;

  return (
    <IconButton {...rest} color={color} variant={"contained"}>
      <Icon type={props.icon} size={24} />
    </IconButton>
  );
})({
  minWidth: "unset !important",
  borderRadius: CORNER_EXTRA_SMALL,
  aspectRatio: "1/1",
});
